if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"servicejob_management","remotes":[{"alias":"spclaims_management","name":"spclaims_management","entry":"https://spclaims.sbx.dev.servicebench.com/remoteEntry.js","shareScope":"default","externalType":"script"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return 564 != chunkId},
		rootOutputDir: "../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"spclaims_management":[{"alias":"spclaims_management","name":"spclaims_management","entry":"https://spclaims.sbx.dev.servicebench.com/remoteEntry.js","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}